// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__waEKu","tooltip-text":"tooltip_tooltip-text__rMv7n"};